import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";

export async function getMenuEngineSidebar(headers, { includeLocked = false } = {}) {
  const response = await axios.get(ApiLink.API_URL + "MenuEngine/sidebar", {
    headers,
    params: includeLocked ? { includeLocked: true } : undefined,
    timeout: 15000,
  });

  return response.data;
}
